import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { RouterModule, Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Breadcrumb } from 'primeng/breadcrumb';
import { MenuItem } from 'primeng/api';
import { filter } from 'rxjs';
import { RiberaAvatarUi } from '@ribera-web/ribera-avatar-ui';
import { AuthAdminStore } from '@ribera-web/auth-data-acess';

@Component({
  selector: 'lib-header',
  imports: [CommonModule, RouterModule, Breadcrumb, RiberaAvatarUi],
  templateUrl: './header.html',
  styleUrl: './header.scss',
})
export class Header implements OnInit {

  authStore = inject(AuthAdminStore);

  ngOnInit(): void {
    this.items = this.buildBreadcrumb(this.route.root);
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.items = this.buildBreadcrumb(this.route.root);
      });
  }

  private router = inject(Router);
  private route = inject(ActivatedRoute);

  items: MenuItem[] = [];

  home: MenuItem = { icon: 'home-svg', routerLink: '/' };

  initial = "A" ;
  username = "Administrador" ;
  typeDocument = "DNI" ;
  documentNumber = "12345678X" ;

  menuVisible = false;
  
  get currentSectionTitle(): string {
    const lastItem = this.items[this.items.length - 1];
    return lastItem?.label || 'Administrador';
  }

  get currentUserLabel(): string {
    const username = this.authStore.userLoginData()?.name?.trim();
    return username ? `Usuario: ${username}` : '';
  }

  toggleMobileMenu() {
    window.dispatchEvent(new CustomEvent('admin-mobile-menu-toggle'));
  }
  
  toggleMenu() {
    this.menuVisible = !this.menuVisible;
  }

  closeMenu() {
    this.menuVisible = false;
  }
  
  get menuIcon(): string {
    return this.menuVisible
      ? '/header/icons/arrowdown-icon.svg'
      : '/header/icons/arrowup-icon.svg';
  }

  viewNotifications() {
    this.router.navigate(['/notifications']);
  }

  private buildBreadcrumb(route: ActivatedRoute, url = '', breadcrumbs: MenuItem[] = []): MenuItem[] {
  const children: ActivatedRoute[] = route.children;

  for (const child of children) {
    // Construye la URL parcial de este child
    const routeURL = child.snapshot.url.map(segment => segment.path).join('/');
    if (routeURL !== '') {
      url += `/${routeURL}`;

      // Label con mayúscula inicial y guiones reemplazados
      const rawLabel = child.snapshot.data['breadcrumb'] || routeURL.replace(/-/g,' ').replace(/\//g,' ');
      const label = rawLabel.charAt(0).toUpperCase() + rawLabel.slice(1);

      breadcrumbs.push({ label, routerLink: url });
    }

    // Recurse en los hijos del child
    this.buildBreadcrumb(child, url, breadcrumbs);
  }

  return breadcrumbs;
}
}
